<template>
  <div class="n-footer">
    <div class="footer-content">
      <!-- 主要链接区域 -->
      <div class="footer-links">
        <div class="link-group">
          <h4>快速导航</h4>
          <a href="/" class="footer-link">
            <i class="link-icon">🏠</i>
            网站首页
          </a>
          <a href="/#/ac1" class="footer-link">
            <i class="link-icon">📰</i>
            行业资讯
          </a>
        </div>
        
        <div class="link-group">
          <h4>关于我们</h4>
          <a href="/#/info" class="footer-link">
            <i class="link-icon">🏢</i>
            公司简介
          </a>
         
        </div>
        
        <div class="link-group">
          <h4>法律信息</h4>
          <a href="/#/xy" class="footer-link">
            <i class="link-icon">📄</i>
            用户协议
          </a>
          <a href="/#/ac4" class="footer-link">
            <i class="link-icon">🔒</i>
            隐私政策
          </a>
        </div>
      </div>

      <!-- 分割线 -->
      <div class="footer-divider"></div>

      <!-- 版权信息区域 -->
      <div class="footer-info">
        <div class="company-info">
          <div class="info-item">
            <i class="info-icon">©</i>
            <span>2026 京游科技（北京）有限公司</span>
            <!-- - - 
            <span>联络座机：010-52118888</span> -->
          </div>
         
          <div class="info-item">
            <i class="info-icon">📍</i>
            <span>地址：北京市房山区良乡长虹西路翠柳东街1号-4468</span>
          </div>
        </div>
        
        <div class="icp-info">
          <div class="icp-item">
            <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" class="icp-link">
              备案：京ICP备19046667号-2
            </a>
          </div>
        </div>
      </div>

      <!-- 装饰元素 -->
      <div class="footer-decoration">
        <div class="decoration-line"></div>
        <div class="decoration-dot"></div>
        <div class="decoration-line"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-footer",
  props: {
    email: String,
    phone: String,
    icp: String,
    name: String,
    addr: String,
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.n-footer {
  width: 100%;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #1890ff, #52c41a, transparent);
  }

  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 50px 20px 30px;
    
    // 链接区域
    .footer-links {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 40px;
      margin-bottom: 40px;
      
      .link-group {
        h4 {
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 20px;
          position: relative;
          padding-left: 12px;
          
          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 16px;
            background: linear-gradient(135deg, #1890ff, #52c41a);
            border-radius: 2px;
          }
        }
        
        .footer-link {
          display: flex;
          align-items: center;
          gap: 10px;
          color: #b0b0b0;
          text-decoration: none;
          padding: 8px 0;
          transition: all 0.3s ease;
          border-radius: 6px;
          
          &:hover {
            color: #1890ff;
            transform: translateX(8px);
            background: rgba(255, 255, 255, 0.05);
            padding-left: 12px;
            
            .link-icon {
              transform: scale(1.2);
            }
          }
          
          .link-icon {
            font-size: 14px;
            transition: transform 0.3s ease;
          }
        }
      }
    }
    
    // 分割线
    .footer-divider {
      width: 100%;
      height: 1px;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
      margin: 30px 0;
    }
    
    // 版权信息
    .footer-info {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      flex-wrap: wrap;
      gap: 30px;
      
      .company-info {
        display: flex;
        flex-direction: column;
        gap: 12px;
        flex: 1;
        
        .info-item {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #8c8c8c;
          font-size: 14px;
          
          .info-icon {
            font-size: 12px;
            opacity: 0.7;
          }
          
          &:first-child {
            color: #fff;
            font-weight: 500;
          }
        }
      }
      
      .icp-info {
        .icp-item {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 16px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 20px;
          transition: all 0.3s ease;
          
          &:hover {
            background: rgba(255, 255, 255, 0.1);
            transform: translateY(-2px);
          }
          
          .icp-icon {
            width: 16px;
            height: 16px;
            filter: brightness(0.8);
          }
          
          .icp-link {
            color: #b0b0b0;
            text-decoration: none;
            font-size: 12px;
            transition: color 0.3s ease;
            
            &:hover {
              color: #1890ff;
            }
          }
        }
      }
    }
    
    // 装饰元素
    .footer-decoration {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      margin-top: 40px;
      
      .decoration-line {
        flex: 1;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
      }
      
      .decoration-dot {
        width: 6px;
        height: 6px;
        background: #1890ff;
        border-radius: 50%;
        animation: pulse 2s infinite;
      }
    }
  }
}

// 脉冲动画
@keyframes pulse {
  0%, 100% {
    opacity: 0.5;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
    box-shadow: 0 0 10px #1890ff;
  }
}

// 入场动画
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.n-footer {
  animation: fadeInUp 0.6s ease forwards;
}

// 响应式调整
@media (max-width: 768px) {
  .footer-content {
    .footer-links {
      grid-template-columns: 1fr !important;
      gap: 30px !important;
    }
    
    .footer-info {
      flex-direction: column;
      align-items: flex-start !important;
    }
  }
}
</style>